import { IKb3dModel, Kb3dModels } from './model-utils';

export function Kb3dService<T = any>(options: Partial<IKb3dModel<T>> & Pick<IKb3dModel<T>, 'token'>) {
    const $type = options.token.key;

    return <C extends { new (...args: any[]): any }>(constructor: C) => {
        constructor.prototype.$type = $type;
        options.classConstructor = constructor;
        Kb3dModels.set(options.token, options as IKb3dModel<T>);
    };
}
